export default [
    {
        path: '/affiliates',
        name: 'Affiliates',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Affiliate partners',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesIndex.vue'),
        },
    },
    {
        path: '/affiliates/create',
        name: 'AffiliatesCreate',
        props: {
            default: () => ({ isCreate: true }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create Affiliate',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesForm.vue'),
        },
    },
    {
        path: '/affiliates/:id/edit',
        name: 'AffiliatesEdit',
        props: {
            default: (route) => ({ id: route.params.id, isCreate: false }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Edit Affiliate',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesForm.vue'),
        },
    },
    {
        path: '/affiliates/leads',
        name: 'AffiliatesLeads',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Affiliate leads',
        },
        components: {
            default: () => import('@views/affiliates/AffiliatesLeads.vue'),
        },
    },
];
